export { useTrackingBeacons } from './useTrackingBeacons';
